import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/layout';
import Clients from './components/clients/clients';
import Vendor from './components/vendor/vendor';
import MISReport from './components/mis_report/mis_report';
import Users from './components/users/users';
import LoginPage from './components/auth/LoginPage';
import SignupPage from './components/auth/SignupPage';
import SubUserFirstLogin from './components/auth/SubUserFirstLogin';
import SplashScreen from './components/SplashScreen';
import "./styles.css";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && <SplashScreen onFinished={() => setShowSplash(false)} />}
      <AuthProvider>
        <Router>
          <Routes>
            {/* Auth Routes (without Layout) */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<SignupPage />} />
            <Route path="/sub-user-login" element={<SubUserFirstLogin />} />

            {/* Protected Routes (with Layout) */}
            <Route path="/" element={<ProtectedRoute><Layout><Clients /></Layout></ProtectedRoute>} />
            <Route path="/vendor" element={<ProtectedRoute><Layout><Vendor /></Layout></ProtectedRoute>} />
            <Route path="/mis-report" element={<ProtectedRoute><Layout><MISReport /></Layout></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute><Layout><Users /></Layout></ProtectedRoute>} />
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
